<template>
  <div>
    <el-tabs
      ref="tabs"
      v-model="currentTabName"
      class="order-test-tabs"
    >
      <el-tab-pane v-if="isShowHighlightTab" name="highlights">
        <template v-slot:label>
          <OrderTestTestTabLabel :count="0" label="Vibrant Highlights" />
        </template>
        <VaPromoPanel :promo-list="highlightsDisplay" />
      </el-tab-pane>
      <!-- va test -->
      <el-tab-pane v-if="vaBfsList.length > 0 && !isVaPanelHidden" name="va">
        <template v-slot:label>
          <OrderTestTestTabLabel :count="selectedVaTestCount" label="VA" />
        </template>
        <NewVaTestTabPane
          ref="vaTestTabPane"
          :root-for-searched-va-test="rootForSearchedVaTest"
          :searched-va-test="searchedVaTest"
          :screen-width="screenWidth"
          :select-prop="selectProp"
          :is-not-allowed-select-prop="isNotAllowedSelectProp"
          :order-test-support-obj="orderTestSupportObj"
          :va-root-node-list="vaRootNodeList"
        />
      </el-tab-pane>
      <!-- vw test -->
      <el-tab-pane name="vw">
        <template v-slot:label>
          <OrderTestTestTabLabel :count="selectedVwTestCount" label="VW" />
        </template>
        <NewVwTestTabPane
          :root-for-searched-vw-test="rootForSearchedVwTest"
          :searched-vw-test="searchedVwTest"
          :select-prop="selectProp"
          :is-not-allowed-select-prop="isNotAllowedSelectProp"
          :order-test-support-obj="orderTestSupportObj"
          :serum-categorized-vw-tests="serumCategorizedVwTests"
          :dbs-categorized-vw-tests="dbsCategorizedVwTests"
        />
      </el-tab-pane>
      <!-- regenere test -->
      <el-tab-pane v-if="regenereNodeList.length > 0" name="regenere">
        <template v-slot:label>
          <div class="tab-label-with-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
              <path d="M17.89 9.75C17.96 10.16 18 10.57 18 11C18 15.41 14.41 19 10 19C5.59 19 2 15.41 2 11C2 10.95 2.01 10.9 2 10.86C4.6 9.88 6.69 7.87 7.74 5.31C11.12 9.45 15.71 9.04 16.73 8.92L15.84 6.99C15.71 7 11.22 7.37 8.66 3.13C9.67 2.97 10.37 2.98 11.25 3.12C13.77 1.97 13.18 2.23 14.01 1.86C12.78 1.3 11.43 1 10 1C4.48 1 0 5.48 0 11C0 16.52 4.48 21 10 21C15.52 21 20 16.52 20 11C20 9.57 19.7 8.22 19.16 6.99L17.89 9.75ZM6.08 4.03C5.45 5.92 4.13 7.5 2.42 8.47C3.05 6.58 4.37 5 6.08 4.03Z" fill="#374957"/>
              <path d="M13 13.25C13.6904 13.25 14.25 12.6904 14.25 12C14.25 11.3096 13.6904 10.75 13 10.75C12.3096 10.75 11.75 11.3096 11.75 12C11.75 12.6904 12.3096 13.25 13 13.25Z" fill="#374957"/>
              <path d="M7 13.25C7.69036 13.25 8.25 12.6904 8.25 12C8.25 11.3096 7.69036 10.75 7 10.75C6.30964 10.75 5.75 11.3096 5.75 12C5.75 12.6904 6.30964 13.25 7 13.25Z" fill="#374957"/>
              <path d="M21 3.5L18.6 2.4L17.5 0L16.4 2.4L14 3.5L16.4 4.6L17.5 7L18.6 4.6L21 3.5Z" fill="#374957"/>
            </svg>
            <OrderTestTestTabLabel :count="selectedRegenereTestCount" label="Regenere" />
          </div>
        </template>
        <RegenereTestTabPane
          :regenere-test-list="regenereNodeList"
          :root-for-searched-regenere-test="rootForSearchedRegenereTest"
          :searched-regenere-test="searchedRegenereTest"
          :select-prop="selectProp"
          :is-not-allowed-select-prop="isNotAllowedSelectProp"
          :order-test-support-obj="orderTestSupportObj"
        />
      </el-tab-pane>
      <!-- nutriproz test -->
      <el-tab-pane v-if="nutriprozNodeList.length > 0" name="nutriproz">
        <template v-slot:label>
          <div class="tab-label-with-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M14.5 3H2.5V5H14.5V3Z" fill="#374957"/>
              <path d="M1.5 21H15.5V6H1.5V21ZM4.5 12H7V9.5H10V12H12.5V15H10V17.5H7V15H4.5V12Z" fill="#374957"/>
              <path d="M19.5 6C17.82 6 16.5 7.76 16.5 10C16.5 11.77 17.33 13.22 18.5 13.76V21H20.5V13.76C21.67 13.22 22.5 11.77 22.5 10C22.5 7.76 21.18 6 19.5 6Z" fill="#374957"/>
            </svg>
            <OrderTestTestTabLabel :count="selectedNutriprozTestCount" label="NutriProZ" />
          </div>
        </template>
        <NutriProZTestTabPane
          :nutriproz-test-list="nutriprozNodeList"
          :root-for-searched-nutri-pro-z-test="rootForSearchedNutriProZTest"
          :searched-nutri-pro-z-test="searchedNutriProZTest"
          :select-prop="selectProp"
          :is-not-allowed-select-prop="isNotAllowedSelectProp"
          :order-test-support-obj="orderTestSupportObj"
        />
      </el-tab-pane>
      <!-- custom panel -->
      <el-tab-pane v-if="customPanelList.length > 0" name="customPanel">
        <template v-slot:label>
          <div class="tab-label-with-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" fill="#374957"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.49 9.38C11.92 8.16 11.66 6.74 10.68 5.76C9.57 4.65 7.89 4.46 6.58 5.17L8.93 7.52L7.52 8.93L5.17 6.58C4.46 7.9 4.65 9.57 5.76 10.68C6.74 11.66 8.16 11.92 9.38 11.49L12.79 14.9C12.99 15.1 13.3 15.1 13.5 14.9L14.9 13.5C15.1 13.3 15.1 12.99 14.9 12.79L11.49 9.38Z" fill="#374957"/>
            </svg>
            <OrderTestTestTabLabel :count="selectedCustomPanelCount" label="Custom Panel" />
          </div>
        </template>
        <CustomPanel
          :select-prop="selectProp"
          :orderTestSupportObj="orderTestSupportObj"
          :custom-panel-list="customPanelList"
        />
      </el-tab-pane>
      <!-- Shortcut Bundles Tab -->
      <el-tab-pane v-if="isShowShortcutBundlesTab" name="shortcutBundles">
        <template v-slot:label>
          <div class="tab-label-with-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M4 3H16C17.1 3 18 3.9 18 5V15C18 16.1 17.1 17 16 17H4C2.9 17 2 16.1 2 15V5C2 3.9 2.9 3 4 3ZM4 5V15H16V5H4Z" fill="#374957"/>
              <path d="M7 7H9V9H7V7Z" fill="#374957"/>
              <path d="M11 7H13V9H11V7Z" fill="#374957"/>
            </svg>
            <OrderTestTestTabLabel
              :count="selectedShortcutBundlesCount"
              label="Shortcut Bundles"
            />
          </div>
        </template>
        <ShortcutBundlesTab
          ref="shortcutBundlesTabRef"
          @selection-change="handleShortcutSelectionChange"
        />
      </el-tab-pane>
      <!-- discount panel -->
      <el-tab-pane v-if="isShowDiscountPanelTab" name="discountPanel">
        <template v-slot:label>
          <OrderTestTestTabLabel :count="selectedDiscountPanelCount" label="Discount Panel" />
        </template>
        <DiscountPanelTabPane
          :searched-discount-panel="searchedDiscountPanel"
          :clear-all-filters-trigger="clearAllFiltersTrigger"
          :select-prop="selectProp"
          :order-test-support-obj="orderTestSupportObj"
        />
      </el-tab-pane>
      <el-tab-pane v-if="isShowMerchTab" name="merchPanel">
        <template v-slot:label>
          <OrderTestTestTabLabel
            :count="selectedMerchCount"
            label="Practice Product"
          />
        </template>
        <MerchPanel />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import OrderTestTestTabLabel from "./OrderTestTabLabel.vue";
import RegenereTestTabPane from "./RegenereTestTabPane.vue";
import NutriProZTestTabPane from "./NutriprozTestTabPane.vue";
import DiscountPanelTabPane from "./discount-panel-tab-pane/index.vue";
import MerchPanel from "./merch-panel/index.vue"
import VaPromoPanel from "../../promo-panel/index.vue";
import NewVwTestTabPane from "./NewVwTestTabPane.vue";
import NewVaTestTabPane from "./NewVaTestTabPane.vue";
import CustomPanel from "../../custom-panel/index.vue";
import ShortcutBundlesTab from "@/views/MyPatient-demo/ShortcutBundlesTab.vue";
import { mapState, mapGetters } from "vuex";
import _ from "lodash";
export default {
  components: {
    OrderTestTestTabLabel,
    RegenereTestTabPane,
    NutriProZTestTabPane,
    DiscountPanelTabPane,
    MerchPanel,
    NewVwTestTabPane,
    NewVaTestTabPane,
    CustomPanel,
    VaPromoPanel,
    ShortcutBundlesTab,
  },
  props: {
    searchedItem: {
      type: Object,
      default: () => {}
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    orderTestSupportObj: {
      type: Object,
      default: () => {}
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },
    isShowDiscountPanelTab: {
      type: Boolean,
      default: true
    },
    displayItemData: {
      type: Object,
      default: null
    },
    isShowSeasonalTab: {
      type: Boolean,
      default: true
    },
    isShowMerchTab: {
      type: Boolean,
      default: true,
    },
    customPanelList: {
      type: Array,
      default: () => [],
    },
    highlightList: {
      type: Array,
      default: () => [],
    },
    isShowHighlightTab: {
      type: Boolean,
      default: false,
    },
    isShowShortcutBundlesTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentTabName: this.isShowHighlightTab ? "highlights" : "va",
      searchedVaTest: {},
      rootForSearchedVaTest: {},
      searchedVwTest: {},
      rootForSearchedVwTest: {},
      searchedRegenereTest: {},
      rootForSearchedRegenereTest: {},
      searchedNutriProZTest: {},
      rootForSearchedNutriProZTest: {},
      searchedDiscountPanel: {},
      screenWidth: 0,
      categorizedSeasonalPromos: [],
      clearAllFiltersTrigger: 0
    };
  },

  computed: {
    ...mapState("orderTest", ["isDbsVersion"]),
    ...mapState("orderTest/tests", ["regenereIdList", "nutriprozIdList", "isVaPanelHidden"]),
    ...mapState("orderTest/promotions", ["seasonalPromotionList"]),
    ...mapGetters("orderTest/merchandise", ["selectedMerchList"]),

    vaRootNodeList() {
      return this.displayItemData?.vaRootNodeList || [];
    },
    serumCategorizedVwTests() {
      return this.displayItemData?.serumCategorizedVwTests || [];
    },
    dbsCategorizedVwTests() {
      return this.displayItemData?.dbsCategorizedVwTests || [];
    },
    testNodeList() {
      return this.displayItemData?.bfsTestList || [];
    },
    testList() {
      return this.displayItemData?.testList || [];
    },
    vaBfsList() {
      return this.displayItemData?.vaBfsList || [];
    },
    vwBfsList() {
      return this.displayItemData?.vwBfsList || [];
    },
    bundleList() {
      return this.displayItemData?.bundleList || [];
    },
    discountPanelList() {
      return this.displayItemData?.discountPanelList || [];
    },
    serumDiscountPanelList() {
      return this.displayItemData?.serumDiscountPanelList || [];
    },
    dbsDiscountPanelList() {
      return this.displayItemData?.dbsDiscountPanelList || [];
    },
    regenereNodeList() {
      return this.displayItemData?.regenereNodeList || [];
    },
    nutriprozNodeList() {
      return this.displayItemData?.nutriprozNodeList || [];
    },

    selectedVaTestCount() {
      return this.vaBfsList.filter(node => node.value[this.selectProp]).length;
    },
    selectedVwTestCount() {
      let vwTestCounts = this.vwBfsList.filter(node =>
        node.value[this.selectProp] &&
        !node.value.toBeOffline &&
        !this.regenereIdList.includes(node.id) &&
        !this.nutriprozIdList.includes(node.id)
      ).length;
      return vwTestCounts;
    },
    selectedDiscountPanelCount() {
      return this.discountPanelList.filter(panel => panel[this.selectProp] && !panel.toBeOffline).length;
    },
    selectedSeasonalPromoCount() {
      return this.seasonalPromotionList.filter((promo) => promo[this.selectProp]).length;
    },
    selectedMerchCount() {
      return this.selectedMerchList.length;
    },
    selectedRegenereTestCount() {
      return this.regenereNodeList.filter(node => node.value[this.selectProp]).length;
    },
    selectedNutriprozTestCount() {
      return this.nutriprozNodeList.filter(node => node.value[this.selectProp]).length;
    },
    selectedCustomPanelCount() {
      return this.customPanelList.filter(panel => panel[this.selectProp]).length;
    },
    selectedShortcutBundlesCount() {
      return (this.$store.getters['orderTest/favorites/selectedShortcutList'] || []).length;
    },
    highlightsDisplay() {
      const highlightDbsVersion = this.isDbsVersion ? "at_home" : "not_at_home";
      return (this.highlightList || []).filter(
        (highlight) => highlight.section === highlightDbsVersion || highlight.section === "both"
      );
    },
  },

  watch: {
    searchedItem(newVal, oldVal) {
      if (_.isEmpty(newVal)) {
        this.initializeSearchTest();
        return;
      }
      if (newVal.isMerch) {
         this.currentTabName = "merchPanel";
         return;
       }

      // find searched test or bundle
      if (!newVal.type) {
        // discount panel
        let foundPanel = this.bundleList.find(
          (bundle) => bundle.bundleId === newVal.id
        );
        this.currentTabName = "discountPanel";
        this.searchedDiscountPanel = foundPanel;
      } else {
        // va, vw, regenere, or nutriproz test
        let testNodeList = this.vaBfsList.concat(this.vwBfsList);
        let foundTest = testNodeList.find((test) => test.id === newVal.id);
        if (!foundTest) return;

        // find the root of tree (exclude the offline test) that the foundTest belongs to
        let root = foundTest;
        while (root.parent !== null) {
          if (root.parent.value.toBeOffline) {
            break;
          }
          root = root.parent;
        }

        // Check if it's Regenere or NutriProZ
        if (this.regenereIdList.includes(foundTest.id)) {
          this.currentTabName = "regenere";
          this.searchedRegenereTest = foundTest.value;
          this.rootForSearchedRegenereTest = root;
        } else if (this.nutriprozIdList.includes(foundTest.id)) {
          this.currentTabName = "nutriproz";
          this.searchedNutriProZTest = foundTest.value;
          this.rootForSearchedNutriProZTest = root;
        } else {
          this.currentTabName = foundTest.value.category;
          if (this.currentTabName === "va") {
            this.searchedVaTest = foundTest.value;
            this.rootForSearchedVaTest = root;
          } else {
            this.searchedVwTest = foundTest.value;
            this.rootForSearchedVwTest = root;
          }
        }
      }
    },

    isVaPanelHidden(isHidden) {
      if (!isHidden) return;
      if (this.currentTabName === "va") {
        this.currentTabName = "vw";
        this.removeButton();
      }
      this.$store.dispatch("orderTest/clearVaSelections");
    },

    isDbsVersion() {
      if (!this.isDbsVersion && this.currentTabName === "special") {
        this.currentTabName = "va";
      }
      this.categorizedSeasonalPromos = this.getCategorizedSeasonalPromos()
    },

    seasonalPromotionList() {
      this.categorizedSeasonalPromos = this.getCategorizedSeasonalPromos();
    },

    serumDiscountPanelList() {
      this.categorizedSeasonalPromos = this.getCategorizedSeasonalPromos();
    },
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },

  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },

  mounted() {
    if (this.isShowHighlightTab && this.currentTabName === "va") {
      this.currentTabName = "highlights";
    } else if (this.isDbsVersion && this.currentTabName === "va") {
      this.currentTabName = "vw";
    }
    if (!this.isDbsVersion && this.currentTabName === "special") {
      this.currentTabName = "va";
    }
    if ((this.vaBfsList.length === 0 || this.isVaPanelHidden) && !this.isShowHighlightTab) {
      this.currentTabName = "vw";
    }
    this.categorizedSeasonalPromos = this.getCategorizedSeasonalPromos();
    this.addTestInUrl(this.$route.query);
  },

  methods: {
    initializeSearchTest() {
      this.rootForSearchedVaTest = {};
      this.searchedVaTest = {};
      this.rootForSearchedVwTest = {};
      this.searchedVwTest = {};
      this.rootForSearchedRegenereTest = {};
      this.searchedRegenereTest = {};
      this.rootForSearchedNutriProZTest = {};
      this.searchedNutriProZTest = {};
      this.searchedDiscountPanel = {};
      this.clearAllFiltersTrigger += 1;
    },

    handleResize() {
      this.screenWidth = window.innerWidth;
    },

    getCategorizedSeasonalPromos() {
      if (this.seasonalPromotionList.length === 0 || this.serumDiscountPanelList.length === 0)
        return [];
      let result = new Set();
      let discountPanels = this.isDbsVersion ? this.dbsDiscountPanelList : this.serumDiscountPanelList;
      this.seasonalPromotionList.forEach(promo => {
        promo.appliedBundles.forEach(bundleId => {
          if (discountPanels.find(b => b.bundleId === bundleId)) {
            result.add(promo);
          }
        });
        promo.appliedTests.forEach(testId => {
          let test = this.testList.find(t => t.id === testId);
          if (test) {
            let { blood, nonBlood, dryIce } = test.sampleTypeSets;
            if (this.isDbsVersion) {
              if (blood.size === 0 && dryIce.size === 0) {
                result.add(promo);
              }
            }
            else {
              if (!nonBlood.has("DBS")) {
                result.add(promo);
              }
            }
          }
        });
      });
      return [...result];
    },

    addTestInUrl(query) {
      if (query && query["item-id"] && query["item-type"] === "test") {
        let itemIds = String(query["item-id"]);
        let idList = [];
        if (typeof itemIds === 'string' && itemIds.includes(',')) {
          idList = itemIds.split(',').map(id => Number(id.trim())).filter(id => !isNaN(id));
        } else {
          idList = [Number(itemIds)];
        }
        idList.forEach(testId => {
          let test = this.testList.find(p => p.id === testId);
          if (!test) return;
          let currentMenu = this.isDbsVersion ? "at_home" : "not_at_home";
          if (!["both", currentMenu].includes(test.section)) {
            this.$store.dispatch("orderTest/setIsDbsVersion", !this.isDbsVersion);
          }
          this.$store.dispatch("orderTest/addSelectedTest", { id: testId });
        });
      }
    },

    handleShortcutSelectionChange(selectedList, totalPrice) {
      this.$emit('shortcut-selection-change', selectedList, totalPrice);
    }

  },
};
</script>

<style scoped>
/* Pill-style tab selector */
.order-test-tabs :deep(.el-tabs__header) {
  margin-bottom: 16px;
  background: none;
  border-bottom: none;
}

.order-test-tabs :deep(.el-tabs__nav-wrap::after) {
  display: none;
}

.order-test-tabs :deep(.el-tabs__nav-wrap) {
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}

.order-test-tabs :deep(.el-tabs__nav-wrap::-webkit-scrollbar) {
  display: none;
}

.order-test-tabs :deep(.el-tabs__nav-scroll) {
  overflow: visible !important;
}

.order-test-tabs :deep(.el-tabs__nav) {
  display: flex;
  align-items: center;
  gap: 10px;
  width: max-content;
}

.order-test-tabs :deep(.el-tabs__item) {
  display: flex;
  padding: 4px 16px !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 20px;
  background: rgba(211, 241, 243, 0.35);
  color: var(--SecondaryBlack, #666);
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  text-align: center;
  border: none;
  margin: 0;
  transition: all 0.2s ease;
}

.order-test-tabs :deep(.el-tabs__item:hover) {
  color: var(--TrueBlack, #333);
  background: rgba(211, 241, 243, 0.55);
}

.order-test-tabs :deep(.el-tabs__item.is-active) {
  background: #D3F1F3;
  color: var(--TrueBlack, #333);
}

/* Hide Element Plus default active bar */
.order-test-tabs :deep(.el-tabs__active-bar) {
  display: none;
}

.order-test-tabs :deep(.tab-label-with-icon svg) {
  display: none;
}
</style>
